import { render, staticRenderFns } from "./ControlInventario.vue?vue&type=template&id=6138dd13&"
import script from "./ControlInventario.vue?vue&type=script&lang=js&"
export * from "./ControlInventario.vue?vue&type=script&lang=js&"
import style0 from "./ControlInventario.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports